<script lang="ts">
  import { page } from '$app/stores';
  import dayjs from 'dayjs';
  import AuctionFavoriteButton from '$lib/client/auction/AuctionFavoriteButton.svelte';
  import { invalidate } from '$app/navigation';
  import FormattedCurrency from '$lib/client/FormattedCurrency.svelte';
  import SimpleCountdown from '$lib/client/countdown/SimpleCountdown.svelte';
  import { AuctionPriceType as AuctionPriceTypeEnum } from '$lib/const/priceTypes';

  export let id: number;
  export let priceType: string;
  export let priceProposals: boolean;
  export let title: string;
  export let category: string;
  export let quantity: number | null;
  export let endsAt: Date;
  export let ended: boolean;
  export let lastBid: number | null;
  export let startingPrice: number;
  export let isFavorite: boolean;
  export let currencyId: string;
  export let bidsCount: number;
  export let blurPrice = false;

  const numFormatter = Intl.NumberFormat(undefined, { notation: 'standard' });
  $: objEndsAt = dayjs(endsAt);
  $: strEndedAt = objEndsAt.format('LLL');
  $: hoursFromNowToEnds = objEndsAt.diff(dayjs(), 'hour');
  $: milisecondsFromNowToEnds = objEndsAt.diff(dayjs(), 'millisecond');

  $: isLoggedIn = !!$page.data.authUser;
  $: href = `/auctions/${id}`;
</script>

<a
  {href}
  class="d-flex flex-column flex-sm-row position-relative auction-card border rounded text-decoration-none text-body p-3 bg-white"
>
  <div class="col">
    <p class="mb-4 fw-medium">{title}</p>

    <div class="row">
      <div class="fs-7 col">
        <p class="text-black-50">Category</p>
        <span>{category}</span>
      </div>

      {#if quantity}
        <div class="fs-7 col">
          <p class="text-black-50">Units</p>
          <span>{numFormatter.format(quantity)}</span>
        </div>
      {/if}

      {#if ended}
        <div class="fs-7 col">
          <p class="d-block badge text-bg-danger" style="width: max-content">Closed on</p>
          <span class="fs-8">{strEndedAt}</span>
        </div>
      {:else}
        <div class="fs-7 col">
          <p class="text-black-50">Closes in</p>
          <span>
            {#if hoursFromNowToEnds < 24}
              <SimpleCountdown time={milisecondsFromNowToEnds} />
            {:else}
              {dayjs().to(endsAt, true)}
            {/if}
          </span>
        </div>
      {/if}
    </div>
  </div>

  <div class="d-none d-sm-block vr text-secondary" />
  <hr class="d-sm-none text-secondary" />

  <div class="mx-auto align-self-center d-flex flex-column align-items-center w-25" style="min-width: 108px">
    <div class="fs-5 fw-medium mb-1" class:blur={blurPrice}>
      <FormattedCurrency
        amount={priceType === AuctionPriceTypeEnum.FIXED_PRICE ? startingPrice : lastBid ?? startingPrice}
        {currencyId}
        convert={true}
      />
    </div>

    {#if priceType !== AuctionPriceTypeEnum.FIXED_PRICE}
      <div class="fs-8 mb-1 text-secondary">{bidsCount} bids</div>
      <div class="btn btn-primary px-3 mt-1 w-auto flex flex-column">Auction</div>
    {:else}
      {#if priceProposals}
        <div class="fs-8 mb-1 text-secondary text-center">Proposals enabled</div>
      {/if}
      <div class="btn btn-primary px-3 mt-1 w-auto flex flex-column">Buy Now</div>
    {/if}
  </div>

  {#if isLoggedIn}
    <div class="position-absolute end-0 top-0 me-2 mt-2">
      <AuctionFavoriteButton auctionId={id} {isFavorite} onClick={() => invalidate(href)} />
    </div>
  {/if}
</a>

<style>
  .auction-card:hover {
    box-shadow: var(--bs-box-shadow-sm) !important;
  }

  .blur {
    filter: blur(5px);
    user-select: none;
  }
</style>
